var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin_general"},[_c('h1',{staticClass:"admin_general__header"},[_vm._v("Общая информация")]),_c('admin-forum-info'),_c('admin-new-admin'),_c('admin-categories')],1)}
var staticRenderFns = []

export { render, staticRenderFns }